import { LinkField } from '@sitecore-jss/sitecore-jss-react/types/components/Link';

// retrieve link label to render, from one of the possible values
export const getLinkLabel = (linkData: LinkField) => {
  const { href, text, title, url } = linkData?.value || {};
  return text || title || url || href;
};
